import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAuthPopup } from '../hooks/useAuthPopup';
import { useComparison } from '../context/ComparisonContext';
import UserMenu from './UserMenu';
import { Scale } from 'lucide-react';
import './Layout.css';

const Layout = ({ children, isTransparent, scrollable = false }) => {
    const { user } = useAuth();
    const { openAuthPopup } = useAuthPopup();
    const { compareCount } = useComparison();
    const navigate = useNavigate();

    return (
        <div className="layout">
            <header className={`app-header ${isTransparent ? 'transparent' : ''}`}>
                <div className="header-left">
                    <h1 className="logo" onClick={() => navigate('/')}>Revest AI</h1>
                    <nav className="main-nav">
                        <a href="#" className="nav-link">Buy</a>
                    </nav>
                    <nav className="main-nav">
                        <a href="#" className="nav-link">Sell</a>
                    </nav>
                </div>
                <div className="header-right">
                    <a href="#" className="nav-link">Help</a>
                    {compareCount > 0 && (
                        <button className="compare-cart-btn" onClick={() => navigate('/compare')}>
                            <Scale size={20} />
                            <span className="compare-cart-badge">{compareCount}</span>
                        </button>
                    )}
                    {user ? (
                        <UserMenu />
                    ) : (
                        <button onClick={() => openAuthPopup()} className="btn-outline">Sign In</button>
                    )}
                </div>
            </header>
            <main className={`app-content ${scrollable ? 'scrollable' : ''}`}>
                {children}
            </main>
        </div>
    );
};

export default Layout;

